import {
  BooleanParam,
  decodeDelimitedArray,
  encodeDelimitedArray,
  QueryParamConfig,
  StringParam,
  withDefault,
} from "use-query-params";

export const NonNullStringArrayParam = (defaultValue: string[]) =>
  withDefault(
    {
      encode: (array: string[]) => encodeDelimitedArray(array.toSorted(), "__"),
      decode: (arrayStr) =>
        decodeDelimitedArray(arrayStr, "__")?.toSorted() as string[],
    },
    defaultValue,
    false,
  );

export const StringArrayParam: QueryParamConfig<string[] | null> = {
  encode: (array) =>
    array ? encodeDelimitedArray(array.toSorted(), "__") : null,
  decode: (arrayStr) =>
    (decodeDelimitedArray(arrayStr, "__")?.toSorted() as
      | string[]
      | undefined) ?? null,
};

export const NonNullBooleanParam = withDefault(BooleanParam, false);

export const NonNullStringParam = withDefault(StringParam, undefined);
